import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextDiaT1 } from "./TextDiaT1";
import { SourcesDiaT1 } from "./SourcesDiaT1";


export default function Dt1() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};
    
return(
<>      

<Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
           <TextCard 
            textcard={'Diabetes Type 1' }
           />
</Button>

<CustomDialog open={open} onClose={handleClose}

        title='Diabetes Type 1 Genes - Variants'

        content={<TextDiaT1 />}

        sources={<SourcesDiaT1 />}

/>

</>
)}